module.exports = __webpack_public_path__ + "static/aea_medical_help.2027367d.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/public/images/aea_medical_help.jpg
// module id = 145
// module chunks = 0